import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { TermConditionsAction } from "./APIs/action/index";
import useContentProtection from "../Common/useContentProtection";

const TermConditions = ({ inModal = false })  => {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState(null);
  const { onContextMenu, protectionSx } = useContentProtection();

  useEffect(() => {
    const getPolicy = async () => {
        setLoading(true);
        const data = await TermConditionsAction();
        setPolicy(data);
        setLoading(false);
    };
    getPolicy();
  }, []);
  if (!policy) return null;

  return (
    <Box onContextMenu={onContextMenu} sx={{ p: 2, display: 'flex', gap: 2, flexDirection: 'column', ...protectionSx }}>
      {!inModal && <Typography variant="h1">{policy?.title}</Typography>}
      {(policy.tnc)
        ? policy.tnc.map((section, idx) => (
            <Box key={idx}>
              <Typography variant="h2">{section.header}</Typography>
              <Typography variant="body1">{section.description}</Typography>
            </Box>
          ))
        : <Typography variant="body1">{policy.tnc}</Typography>
      }
    </Box>
  );
};

export default TermConditions;